import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconEdit = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <g>
      <rect width="16" height="16" rx="0" fill="none" />
      <path
        d="m6.435 15 7.953-7.952a2.09 2.09 0 0 0 0-2.957l-1.479-1.479a2.09 2.09 0 0 0-2.957 0L2 10.565V15h4.435Zm-2.344-3.57v1.48h1.478l7.34-7.34-1.478-1.48-7.34 7.34Zm5.055 2.51h6.272v1.046H9.146V13.94Z"
        fillRule="evenodd"
        fill={color}
      />
    </g>
  ),
})``;

export default IconEdit;
